export default "let one_day : int = 86_400\n// Type your solution below\n\n";